// extracted by mini-css-extract-plugin
export var actions = "_1q-0";
export var actionsContainer = "_1q-7";
export var border = "_1q-1";
export var childFullHeight = "_1q-f";
export var collapse = "_1q-2";
export var content = "_1q-a";
export var contentChild = "_1q-e";
export var fullscreen = "_1q-c";
export var hasLeftRadius = "_1q-k";
export var headerContainer = "_1q-3";
export var headerRow = "_1q-5";
export var hidePadding = "_1q-b";
export var navCollapsedGap = "_1q-l";
export var noScrollX = "_1q-m";
export var noScrollY = "_1q-n";
export var noTopPadding = "_1q-i";
export var optOutTopPadding = "_1q-d";
export var pageMain = "_1q-j";
export var pageOuter = "_1q-g";
export var pagePadding = "_1q-8";
export var pageScroll = "_1q-9";
export var profile = "_1q-o";
export var profileContainer = "_1q-p";
export var profileImage = "_1q-q";
export var profileMain = "_1q-r";
export var profileSubtitle = "_1q-t";
export var profileTitle = "_1q-s";
export var showLeftPadding = "_1q-h";
export var tabsPortalSlot = "_1q-6";
export var tabsWrapper = "_1q-4";
export var title = "_1q-u";